import { Directive, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[trimInput]',
    providers: [
        {
        provide: NG_VALUE_ACCESSOR,
        useExisting: TrimDirective,
        multi: true
        }
    ]
    })
    export class TrimDirective implements ControlValueAccessor {
    @Input() ngModel: any;

    writeValue(value: any): void {
        this.ngModel = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    onChange = (value: any) => {};
    onTouched = () => {};

    @HostListener('input', ['$event.target.value'])
    onInput(value: string) {
        const trimmedValue = value.trim();
        
        // Only update if the trimmed value is different from the current value
        if (trimmedValue !== this.ngModel) {
        this.ngModel = trimmedValue;
        this.onChange(trimmedValue);
        this.writeValue(trimmedValue);
        }
    }

    @HostListener('blur', ['$event.target.value'])
    onBlur(value: string) {
        const trimmedValue = value.trim();
        
        // Only update on blur if the value has changed
        if (trimmedValue !== this.ngModel) {
        this.writeValue(trimmedValue);
        this.onChange(trimmedValue);
        }
        this.onTouched();
    }
}